module.exports = __webpack_public_path__ + "img/bg2.b4d51a3f.png";